import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { AlertsTableBigForHome } from "./Alerts";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import * as alertTypes from "../../shared/language.json";
import styles from "../../shared/dashboardStyle";
import { strToDate } from "../../shared/StrToDate"

const useStyles = makeStyles(styles);

function AlarmsForHome(props) {
  const { objectForTableFiltering, pointsStore, index } = props;
  const [alarms, setAlarms] = useState([]);
  const classes = useStyles();


  const addPropertyToAlarm = (alarms) => {
    alarms.map((alarm) => {
      if (alarm.alarmSeverity === "Middle") { alarm.alarmSeverityGR = "Μέτριος" }
      else if (alarm.alarmSeverity === "Low") { alarm.alarmSeverityGR = "Χαμηλός" }
      else alarm.alarmSeverityGR = "Υψηλός"
    });
  }

  let openAlarms = [];
  let assignedAlarms = [];
  useEffect(() => {
    if (pointsStore) {
      pointsStore.map((point) => {
        if (point.alarms.length > 0) {
          point.alarms.map((alarm) => {
            if (alarm.statusId === 1) openAlarms.push(alarm);
            if (alarm.statusId === 2) assignedAlarms.push(alarm);
          });
        }
      });

    }

    const sortedOpenAlarms = openAlarms.sort((a, b) => strToDate(b.dateCreated) - strToDate(a.dateCreated));
    addPropertyToAlarm(sortedOpenAlarms);
    const sortedAssignedAlarms = assignedAlarms.sort((a, b) => strToDate(b.dateCreated) - strToDate(a.dateCreated));
    addPropertyToAlarm(sortedAssignedAlarms);
    if (
      !objectForTableFiltering.beneficiaryId &&
      !objectForTableFiltering.alertScore
      && index === 0
    ) {
      setAlarms(sortedOpenAlarms);
    }
    else if (
      !objectForTableFiltering.beneficiaryId &&
      !objectForTableFiltering.alertScore &&
      index === 1) {
      setAlarms(sortedAssignedAlarms);
    }
    else if (
      objectForTableFiltering.beneficiaryId &&
      objectForTableFiltering.statusId === 1 &&
      !objectForTableFiltering.alertScore
    ) {
      setAlarms(
        sortedOpenAlarms.filter(
          (alarm) => alarm.beneficiaryId === objectForTableFiltering.beneficiaryId && alarm.statusId === 1
        ));
    } else if (objectForTableFiltering.beneficiaryId &&
      objectForTableFiltering.statusId === 2 &&
      !objectForTableFiltering.alertScore) {
      setAlarms(
        sortedAssignedAlarms.filter(
          (alarm) => alarm.beneficiaryId === objectForTableFiltering.beneficiaryId && alarm.statusId === 2
        ))
    }
    else if (objectForTableFiltering.beneficiaryId &&
      objectForTableFiltering.statusId === 1 &&
      objectForTableFiltering.alertScore) {
      setAlarms(
        sortedOpenAlarms.filter(
          (alarm) =>
            alarm.beneficiaryId === objectForTableFiltering.beneficiaryId &&
            alarm.alarmSeverity === objectForTableFiltering.alertScore &&
            alarm.statusId === 1
        )
      );
    }
    else if (objectForTableFiltering.beneficiaryId &&
      objectForTableFiltering.statusId === 2 &&
      objectForTableFiltering.alertScore) {
      setAlarms(
        sortedAssignedAlarms.filter(
          (alarm) =>
            alarm.beneficiaryId === objectForTableFiltering.beneficiaryId &&
            alarm.alarmSeverity === objectForTableFiltering.alertScore &&
            alarm.statusId === 2
        )
      );
    }
  }, [objectForTableFiltering, pointsStore]);

  const columns = [
    {
      field: "id",
      title: "Αρ. Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "beneficiaryId",
      title: "Κωδ. Ωφελούμενου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmSeverityGR",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "value",
      title: "Τιμή Ειδοποιήσης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },

  ];

  return (
    <Card>
      <CardHeader color="warning">
        {(index === 0 && !objectForTableFiltering.beneficiaryId) ? <h4 className={classes.cardTitleWhite}>Ανοιχτές Ειδοποιήσεις</h4> : (index === 0 && objectForTableFiltering.beneficiaryId) ? <h4 className={classes.cardTitleWhite}>Ανοιχτές Ειδοποιήσεις Ωφελούμενου με αριθμό: {objectForTableFiltering.beneficiaryId}</h4> :
          (index === 1 && !objectForTableFiltering.beneficiaryId) ? <h4 className={classes.cardTitleWhite}>Ειδοποιήσεις σε Εξέλιξη</h4> : <h4 className={classes.cardTitleWhite}>Ειδοποιήσεις σε Εξέλιξη με αριθμό: {objectForTableFiltering.beneficiaryId}</h4>}
      </CardHeader>
      <CardBody>
        <AlertsTableBigForHome alarms={alarms} columns={columns} />
      </CardBody>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

export default connect(mapStateToProps)(AlarmsForHome);